module.exports = __webpack_public_path__ + "components/flag/static/square/bo-603dc7defc6f874f0185eaebeb04b1d4.svg";